interface DataItem {
  node_id: string | null;
  items?: DataItem[];
}

function eraseNodeId(item: DataItem) {
  item.node_id = null;

  return item;
}

export const removeNodeIdFromItem = (data: DataItem) => {
  if (data.node_id) {
    eraseNodeId(data);
  }

  if (data.items) {
    data.items.forEach(item => removeNodeIdFromItem(item));
  }

  return data;
};
